import { Routes } from '@angular/router';

import { GalleryComponent } from './gallery.component';

export const galleryRoutes: Routes = [
  { path: 'gallery', component: GalleryComponent },
];



// WEBPACK FOOTER //
// ./src/app/gallery/gallery.routes.ts